export default "__VITE_ASSET__DKWgpK1f__"